<script>
    import Collapsible from "./Collapsible.svelte"
</script>

<section id="soluções">
    <div class="title">
        Soluções
    </div>

    <div class="collapsable_container">
        <Collapsible title="Carteira Administrada" group="my-group">
            Gestão da carteira  alinhada com seus interesses, perfil e momento de vida. <br/>
            Um gestor profissional torna-se responsável pela execução da política de investimentos, o que dá celeridade ao processo e maximiza o aproveitamento de oportunidades. <br/>
            <br/>
            Toda a política de investimentos é definida junto com o investidor, que estabelece os limites de risco, objetivos de retorno e restrições que devem ser levadas em conta no momento da alocação de recursos.
        </Collapsible>
        <Collapsible title="Fundos Exclusivos" group="my-group">
            Trabalhando com os profissionais mais qualificados do mercado, os fundos exclusivos são uma modalidade diferenciada de investimentos. <br/>
            <br/>
            Sob a medida de um relacionamento exclusivo, e com as vantagens de um fundo de investimentos, é possível alcançar otimização tributária com uma gestão personalizada e flexível, além das possibilidades de blindagem patrimonial.
        </Collapsible>
        <Collapsible title="Investimentos Offshore" group="my-group">
            Oferecemos soluções de diversificação internacional para seu portfólio, com gestão de recursos no exterior e utilização de estruturas que proporcionem blindagem patrimonial e otimização tributária e sucessória.
        </Collapsible>
        <Collapsible title="Fundos de Investimento" group="my-group">
            A equipe da VLGI Asset conta com profissionais altamente qualificados para fazer a gestão de fundos de investimento com as melhores estratégias do mercado e seleção criteriosa de ativos para as carteiras.
        </Collapsible>
    </div>
</section>

<style lang="scss">
    @use "../styles/variables" as v;

    #soluções {
        background: v.$linear-purple-gradient;
        min-height: 100vh;
        padding: 6em 1em;

        .title {
            width: 18rem;
            height: fit-content;
            max-width: 90%;
            margin: 0 auto;
            color: white;
            border: 2px solid white;
            border-radius: 30px;
            padding: 0.5em 1em;
            font-weight: 400;
            font-size: 1.714rem;
            text-transform: uppercase;
            text-align: center;
        }

        .collapsable_container {
            width: 50rem;
            max-width: 100%;
            margin: 0 auto;
            margin-top: 5rem;
        }

    }

    @media only screen and (min-width: v.$tablet-devices) {
        #soluções {
            padding: 8rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
    }
    @media only screen and (min-width: v.$md-desktop-devices) {
    }
</style>
